import React, { useEffect, useState } from "react";
import {
  IconButton,
  Typography,
  Button,
  Link as MuiLink,
  Grid,
  useMediaQuery,
  Snackbar,
  Alert,
  CircularProgress,
  Divider,
  Box,
} from "@mui/material";
// import GoogleLogin from "react-google-login";

import { Formik } from "formik";
import { validationSchema } from "../../components/Authentication/Login/Validation";
import {
  FormikInput,
  FormikPassword,
} from "../../components/Authentication/Login/FormikAntd";
import { LoginRightPage } from "../../Svg/icons";
import QuikTix_LoginBG from "../../Svg/QuikTiks_LoginBG.svg";
import QuickTixLogo from "../../Images/GX_Logo_White_No_Bg.png";
import BlackQuikTixLogo from "../../Images/GX_Logo_Black_No_Bg.png";
import "../../components/Authentication/Login/LoginPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Checkbox, notification } from "antd";
import {
  useForgotPasswordMutation,
  useLoginMutation,
} from "../../Redux/Slices/Accounts/AccountsapiSlice";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  useGetProfileInformationQuery,
  useGoogleLoginMutation,
} from "../../Redux/apis/ApiSlice";
import { jwtDecode } from "jwt-decode";
import Loader from "../../components/Loader/Loader";
const LoginPage = () => {
  const [onBoarding, setOnboarding] = useState(false);

  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const location = useLocation();
  const navigate = useNavigate();
  const [forgotPassword, { isSuccess, isError, error }] =
    useForgotPasswordMutation();
  const [googleLogin] = useGoogleLoginMutation();
  // State for Remember Me functionality
  const [rememberMe, setRememberMe] = useState(true);
  const [storedEmail, setStoredEmail] = useState("");
  const [storedPassword, setStoredPassword] = useState("");
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const [login, { isLoading }] = useLoginMutation();
  const { data: profileData, refetch } = useGetProfileInformationQuery();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const isMdAbove = useMediaQuery("(min-width:900px)");
  const [eventId, setEventId] = useState("");
  const [eventInviteType, setEventInviteType] = useState("");
  const [userId, setUserId] = useState("");
  const redirectUrl = localStorage.getItem("redirectUrl");
  //Google Sign-In
  function clearRedirectUrl() {
    localStorage.removeItem("redirectUrl");
  }
  // Function to extract values from the redirect URL in local storage
  function extractValues() {
    if (redirectUrl) {
      const urlParts = redirectUrl.split("/");

      // Extracting the last part which contains all the parameters
      const lastPart = urlParts[urlParts.length - 1];

      // Split the last part to separate eventId, inviteType, and userId
      const [eventIdParam, inviteTypeParam, userIdParam] = lastPart.split("&");

      // Extracting the eventId
      const eventId = eventIdParam ? eventIdParam.split("=")[1] : null;

      // Extracting the inviteType
      const inviteType = inviteTypeParam ? inviteTypeParam.split("=")[1] : null;

      // Extracting the userId
      const userId = userIdParam ? userIdParam.split("=")[1] : null;
      // Decoding Base64 for strings only
      function decryptParam(param, isInteger = false) {
        return isInteger ? param : atob(param); // Only decode if it's a string (not an integer)
      }
      // Check if all values are present
      if (eventId && inviteType && userId) {
        const eventIdDec = decryptParam(eventId);
        const eventInviteTypeDec = decryptParam(inviteType);
        const userIdDec = decryptParam(userId);
        setEventId(eventIdDec);
        setEventInviteType(eventInviteTypeDec);
        setUserId(userIdDec);
        return { eventIdDec, eventInviteTypeDec, userIdDec };
      } else {
        console.warn("Event ID, Invite Type, or User ID is missing.");
      }
    } else {
      console.warn("Redirect URL is not found in local storage.");
    }
  }

  // Call the function to extract values
  // const extractedValues = extractValues();

  useEffect(() => {
    extractValues();
    // Check localStorage for saved credentials
    const email = localStorage.getItem("rememberedEmail");
    const password = localStorage.getItem("rememberedPassword");
    if (email && password) {
      setStoredEmail(email);
      setStoredPassword(password);
    }
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    setIsLoginLoading(true);

    // Check if user is online
    if (!navigator.onLine) {
      notification.error({
        message: "No internet connection!",
      });
      setIsLoginLoading(false);
      return;
    }

    try {
      const data = {
        email: values.email,
        password: values.password,
        eventId: eventId,
        eventInviteType: eventInviteType,
        userId: userId,
      };
      const res = await login(data).unwrap();
      if (res.success) {
        localStorage.setItem("authToken", res.token);
        localStorage.setItem("userData", JSON.stringify(res.user));

        // Refetch profile data after successful login
        // await refetch(); // Ensure latest profile data is fetched
        const updatedProfile = await refetch();
        // Check onboarding status
        if (updatedProfile?.data?.user?.onBoarding === false) {
          notification.info({
            message: "Connect Your Payment Account!",
            btn: (
              <Button
                onClick={() => {
                  notification.destroy();
                  sessionStorage.setItem(
                    "navigationState",
                    JSON.stringify({ from: "login" })
                  );
                  navigate("/settings");
                }}
                sx={{
                  backgroundColor: "var(--secondary-color)",
                  color: "white",
                  mt: 1,
                  "&:hover": {
                    backgroundColor: "var(--primary-color)",
                  },
                }}
              >
                Connect Now
              </Button>
            ),
            duration: 0, // Make notification stay until user dismisses it
          });
        }

        // Store credentials if Remember Me is checked
        if (rememberMe) {
          localStorage.setItem("rememberedEmail", values.email);
          localStorage.setItem("rememberedPassword", values.password);
        } else {
          localStorage.removeItem("rememberedEmail");
          localStorage.removeItem("rememberedPassword");
        }

        if (onBoarding) {
          notification.success({
            message: "Onboarding successful!",
          });
        }

        // notification.success({
        //   message: "Login successful!",
        // });

        clearRedirectUrl();

        if (redirectUrl) {
          if (redirectUrl.includes("ticket-booking")) {
            navigate("/search");
          } else {
            navigate(redirectUrl);
          }
        } else {
          navigate("/explore-events");
        }
      }
    } catch (error) {
      if (error?.data?.verificationRequired) {
        try {
          const response = await forgotPassword(values.email).unwrap();
          if (response.success) {
            notification.success({
              message: "Email sent successfully!",
            });
            navigate(
              `/verify-account?email=${encodeURIComponent(
                values.email
              )}&from=register`
            );
          }
        } catch (err) {
          console.error("Failed to send email: ", err);
          notification.error({
            message: "Failed to send email!",
          });
        }
      } else if (error?.data?.message) {
        // Display specific error message (e.g., Invalid email or password)
        notification.error({
          message: error.data.message,
        });
      } else {
        // Handle unexpected server error
        notification.error({
          message: "Server Error. Please retry later.",
        });
      }
    } finally {
      setIsLoginLoading(false);
      setSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  const [token, setToken] = useState(null);
  useEffect(() => {
    const initializeGoogleLogin = () => {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/contacts.readonly",
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("google-signin-button"),
        { theme: "outline", size: "large" }
      );
    };

    if (window.google) {
      initializeGoogleLogin();
    } else {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.onload = initializeGoogleLogin;
      document.body.appendChild(script);
    }
  }, []);

  const handleCredentialResponse = (response) => {
    if (!response.credential) {
      notification.error({
        message: "Google login failed! Please retry.",
      });
      return;
    }

    setIsGoogleLoading(true); // Show loader before login starts

    const decoded = jwtDecode(response.credential);
    const { email, given_name: firstName, family_name: lastName } = decoded;

    const data = {
      email,
      firstName,
      lastName,
      eventId: eventId,
      eventInviteType: eventInviteType,
      userId: userId,
    };

    googleLogin(data)
      .unwrap()
      .then((res) => {
        if (res.success) {
          localStorage.setItem("authToken", res.token);
          localStorage.setItem("userData", JSON.stringify(res.user));

          // notification.success({
          //   message: "Login successful!",
          // });

          clearRedirectUrl();

          if (redirectUrl) {
            if (redirectUrl.includes("ticket-booking")) {
              navigate("/search");
            } else {
              navigate(redirectUrl);
            }
          } else {
            navigate("/explore-events");
          }
        } else {
          notification.error({
            message: "User not found! Please sign up.",
          });
          navigate("/signup");
        }
      })
      .catch((error) => {
        console.error("Error during Google Login:", error);
        const status = error.status || error.response?.status || 500;
        const message =
          error.data?.message || "Something went wrong. Please try again.";

        if (status === 500) {
          notification.error({
            message: "Server Error. Please retry later.",
          });
        } else {
          notification.error({
            message: "Something went wrong. Please retry.",
          });
        }
      })
      .finally(() => {
        setIsGoogleLoading(false); // Hide loader when request completes
      });
  };

  return (
    <Grid container className="login-container">
      <Grid item xs={12} md={6} className="left-section">
        {isMdAbove ? (
          <LoginRightPage />
        ) : (
          //       <img
          //   src={QuikTix_LoginBG}
          //   alt="Login Right Page"
          //   style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          // />
          <img
            src={QuickTixLogo}
            alt="GX Tickets"
            style={{ height: "75px" }}
            onClick={() => navigate("/")}
          />
        )}
      </Grid>
      <GoogleOAuthProvider clientId={clientId}>
        <Box
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            display: { xs: "none", md: "block" },
          }}
        >
          <img
            src={BlackQuikTixLogo}
            alt="GX Tickets"
            style={{ height: "75px", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </Box>
        <Grid item xs={12} md={6} className="right-section">
          <Formik
            enableReinitialize
            initialValues={{
              email: storedEmail || "", // Populate with stored email
              password: storedPassword || "", // Populate with stored password
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, handleSubmit }) => (
              <form className="signup-form" onSubmit={handleSubmit}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: 30,
                    mb: 2,
                  }}
                >
                  Login
                </Typography>

                <Grid sx={{ textAlign: "left" }}>
                  <FormikInput
                    name="email"
                    label={
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: 14,
                        }}
                      >
                        Email
                      </Typography>
                    }
                    size="large"
                    placeholder="E-mail"
                  />
                </Grid>
                <Grid sx={{ textAlign: "left" }}>
                  <FormikPassword
                    name="password"
                    label={
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: 14,
                        }}
                      >
                        Password
                      </Typography>
                    }
                    size="large"
                    placeholder="Password"
                  />
                </Grid>

                <Button
                  variant="outlined"
                  sx={{
                    backgroundColor: "var(--secondary-color)",
                    // borderRadius: 20,
                    color: "white",
                    "&:hover": {
                      color: "grey",
                    },
                    mb: 1.5,
                    mt: 2,
                  }}
                  type="submit"
                  disabled={isLoading || isSubmitting}
                  className="login-button"
                >
                  {isLoginLoading || isSubmitting ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Login"
                  )}
                </Button>

                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pb: 2,
                  }}
                >
                  <Checkbox
                    checked={rememberMe} // Default checked
                    onChange={(e) => setRememberMe(e.target.checked)} // Update state
                  >
                    Remember me
                  </Checkbox>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 300,
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/forget-password")}
                    className="forgot-password"
                    variant="body1"
                    color="text.secondary"
                  >
                    Forgot Password
                  </Typography>
                </Grid>

                <Box display="flex" alignItems="center" width="100%" my={2}>
                  <Divider sx={{ flexGrow: 1, bgcolor: "black" }} />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      color: "var(--secondary-color)",
                      mx: 2, // Adds spacing between text and dividers
                    }}
                  >
                    OR
                  </Typography>
                  <Divider sx={{ flexGrow: 1, bgcolor: "black" }} />
                </Box>

                <IconButton
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!navigator.onLine) {
                      notification.error({
                        message: "No internet connection!",
                      });
                      return; // Prevents Google login popup from opening
                    }

                    // Trigger Google sign-in manually (assuming `google.accounts.id.prompt()` is used)
                    document.getElementById("google-signin-button")?.click();
                  }}
                >
                  {/* <div id="google-signin-button"> Continue with Google</div> */}
                  {isGoogleLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <div id="google-signin-button"> Continue with Google</div>
                  )}
                </IconButton>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{
                    fontWeight: 400,
                    fontSize: 16,
                    mb: 0.5,
                  }}
                >
                  Don't have an account?
                </Typography>

                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: 16,
                    mb: 2,
                  }}
                >
                  <MuiLink
                    sx={{
                      fontWeight: 400,
                      fontSize: 16,

                      color: "black",
                    }}
                    href={`/register?eventId=${eventId}&eventInviteType=${eventInviteType}`}
                  >
                    Sign up here!
                  </MuiLink>
                </Typography>
              </form>
            )}
          </Formik>
        </Grid>
      </GoogleOAuthProvider>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        action={
          <Button color="inherit" onClick={handleCloseSnackbar}>
            Close
          </Button>
        }
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default LoginPage;
